import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "wizard-command-step-overview step-overview" }
const _hoisted_2 = { class: "left-panel" }
const _hoisted_3 = { class: "card__head d-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center text-uppercase mb-0" }
const _hoisted_5 = { class: "bt-icon bt-icon--m" }
const _hoisted_6 = { class: "ml-2" }
const _hoisted_7 = { class: "ml-3" }
const _hoisted_8 = {
  key: 0,
  class: "list-blocks"
}
const _hoisted_9 = { class: "object__head" }
const _hoisted_10 = { class: "object__icon bt-icon bt-icon--s" }
const _hoisted_11 = { class: "object__title" }
const _hoisted_12 = { class: "object__channel" }
const _hoisted_13 = { class: "ml-auto" }
const _hoisted_14 = { class: "p-field-checkbox mt-5 align-items-center d-flex ml-3" }
const _hoisted_15 = {
  for: "hiddenToTheUser",
  class: "fw-bold"
}
const _hoisted_16 = {
  key: 0,
  class: "right-panel p-4"
}
const _hoisted_17 = { class: "d-flex right-panel__close" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Card, { class: "card--primary" }, {
        content: _withCtx(() => [
          _createVNode("div", _hoisted_3, [
            _createVNode("h4", _hoisted_4, [
              _createVNode("span", _hoisted_5, [
                _createVNode(_component_InlineSvgScoped, {
                  src: 
                                        require(`@/assets/images/icons/${_ctx.getObjectIconFromType(
                                            _ctx.commandGroup.type
                                        )}.svg`)
                                    ,
                  "aria-label": "icon-blueprint"
                }, null, 8, ["src"])
              ]),
              _createVNode("span", _hoisted_6, _toDisplayString(_ctx.commandGroup.name), 1)
            ]),
            _createVNode("span", _hoisted_7, _toDisplayString(_ctx.getObjectDescLabel(_ctx.commandGroup)), 1)
          ]),
          (_ctx.defaultSettings.length > 0)
            ? (_openBlock(), _createBlock("ul", _hoisted_8, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.defaultSettings, (deviceSetting) => {
                  return (_openBlock(), _createBlock("li", {
                    key: deviceSetting.id,
                    class: "object d-flex"
                  }, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode("div", _hoisted_10, [
                        _createVNode(_component_InlineSvgScoped, {
                          src: 
                                            require(`@/assets/images/icons/${_ctx.getDeviceIconFromSettings(
                                                deviceSetting
                                            )}.svg`)
                                        
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_11, _toDisplayString(deviceSetting.isAggregateRoomObject
                                                ? deviceSetting.identifier
                                                : _ctx.getDeviceName(
                                                      deviceSetting.deviceUid
                                                  )), 1),
                        _createVNode("div", _hoisted_12, _toDisplayString(deviceSetting.activeLinksLabel) + " " + _toDisplayString(_ctx.getDeviceIconName(
                                                deviceSetting.selectedCommandIcon
                                            )), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_13, [
                      (
                                        _ctx.hasDeviceCommandIconButtonVisible(
                                            deviceSetting
                                        )
                                    )
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            onClick: ($event: any) => (
                                        _ctx.showDeviceCommandIcon(deviceSetting)
                                    ),
                            label: 
                                        _ctx.$t('assignObject.step4.commandIcon')
                                    ,
                            class: "p-button-text"
                          }, null, 8, ["onClick", "label"]))
                        : _createCommentVNode("", true),
                      (
                                        _ctx.hasDeviceSettingsButtonVisible(
                                            deviceSetting
                                        )
                                    )
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            onClick: ($event: any) => (_ctx.showDeviceSettings(deviceSetting)),
                            label: _ctx.$t('AppResource.Settings'),
                            class: "ml-2 p-button-text"
                          }, null, 8, ["onClick", "label"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_14, [
        _createVNode(_component_Checkbox, {
          modelValue: _ctx.commandGroup.isHidden,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.commandGroup.isHidden = $event)),
          id: "hiddenToTheUser",
          name: "hiddenToTheUser",
          binary: true
        }, null, 8, ["modelValue"]),
        _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("AppResource.HiddenToTheUser")), 1)
      ])
    ]),
    (_ctx.showRightPanel)
      ? (_openBlock(), _createBlock("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _createVNode(_component_Button, {
              onClick: _ctx.hideRightPanel,
              class: "p-button-text ml-auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_InlineSvgScoped, {
                  width: "30",
                  height: "30",
                  src: require(`@/assets/images/icons/icon-close.svg`)
                }, null, 8, ["src"])
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode(_component_ElScrollbar, null, {
            default: _withCtx(() => [
              (!!_ctx.activeSettingsComponent && !!_ctx.currentDefaultSetting)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeSettingsComponent), {
                    key: 0,
                    defaultSettings: _ctx.currentDefaultSetting,
                    "onUpdate:defaultSettings": _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentDefaultSetting = $event)),
                    deviceName: _ctx.currentDeviceName
                  }, null, 8, ["defaultSettings", "deviceName"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}